import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { useEffect } from "react";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useOrganization } from "../utils/OrganizationContext";
import { Backdrop, CircularProgress } from "@mui/material";

const isTokenExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const currentTime = Math.floor(Date.now() / 1000);
    return payload.exp < currentTime;
  } catch (error) {
    return true;
  }
};

const ProtectedRoute = ({ allowedRoles }) => {
  const user = JSON.parse(localStorage.getItem("user"));
  const orgId = JSON.parse(localStorage.getItem("org"));
  const location = useLocation();
  const { role, isInitializing } = useOrganization();
  const navigate = useNavigate();

  useEffect(() => {
    if (isInitializing || !role || !orgId || !user?.accessToken) {
      return;
    }
    const validateSubscription = async () => {
      const path = location.pathname;
      const search = location.search;
      const allowedPaths = ["/add-lead", "/L", "/inventory"];
      const isAllowedRedirect = allowedPaths.some((p) => path.includes(p));

      const redirect = isAllowedRedirect ? path + search : null;
      try {
        if (role === "SUPERADMIN" || role === "PARTNER") return;
        const endpoint =
          role === "ADMIN"
            ? `/organization/get-by-admin?username=${user.username}&orgId=${orgId}`
            : `/org-user/get-org?username=${user.username}&orgId=${orgId}`;

        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}${endpoint}`,
          {
            headers: {
              Authorization: `Bearer ${user.accessToken}`,
            },
          },
        );

        const { subscription, subscriptionEndDate } = res.data;
        const today = new Date().toISOString().split("T")[0];

        if (subscription !== "FREE" && subscriptionEndDate < today) {
          localStorage.clear();
          window.location.href = "/";
          return;
        }

        localStorage.setItem("subs", JSON.stringify(subscription));
      } catch (error) {
        console.error("Subscription validation failed:", error);
        localStorage.clear();
        navigate(redirect ? `/?redirect=${encodeURIComponent(redirect)}` : "/");
      }
    };

    validateSubscription();
  }, [location.pathname, orgId, role, isInitializing]);

  if (!user || !user.accessToken || isTokenExpired(user.accessToken)) {
    localStorage.clear();
    const path = location.pathname;
    const search = location.search;
    const allowedPaths = ["/add-lead", "/L", "/inventory"];
    const isAllowedRedirect = allowedPaths.some((p) => path.includes(p));

    const redirect = isAllowedRedirect ? path + search : null;
    return (
      <Navigate
        to={redirect ? `/?redirect=${encodeURIComponent(redirect)}` : "/"}
        replace
      />
    );
  }

  if (isInitializing) {
    return (
      <Backdrop
        open
        sx={{
          zIndex: 9999,
          color: "#fff",
        }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }
  // const decoded = jwtDecode(user.accessToken);
  // const role = decoded.role[0];
  if (!allowedRoles.includes(role)) {
    return (
      <Navigate
        to={
          role !== "SUPERADMIN" && role !== "PARTNER"
            ? role === "ADMIN" && location.pathname.includes("/dashboard")
              ? location.pathname.includes("/dashboard/L")
                ? location.pathname.replace("/dashboard", "/dashboard/lead")
                : location.pathname.replace("/dashboard", "/dashboard")
              : location.pathname.includes("/dashboard/lead")
                ? location.pathname.replace(
                    "/dashboard/lead",
                    "/dashboard/lead",
                  )
                : location.pathname.replace("/dashboard", "/dashboard")
            : "/"
        }
        replace
      />
    );
  }

  return <Outlet />;
};

export default ProtectedRoute;
